import React from "react";
import Logo from "../assets/pandawa_logo.png";
import { Link } from "react-router-dom";
import Backdrop from "../assets/steel rols.jpg";
import { PhoneIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import Instagram from "../assets/ig.png";
import LinkedIn from "../assets/linkedin.png";
import WhatsApp from "../assets/logo_wa.png";

const Footer = () => {
  const platStyle = {
    backgroundImage: `url(./assets/steel rols.jpg)`,
    backgroundSize: "cover",
    backgroundPosition: "0% 60%",
    overflow: "hidden",
  };

  return (
    <>
      <Link to="/other-company">
        <section className="bg-primaryPandawa py-2 drop-shadow-2xl">
          <div className="container-screen">
            <div className="grid grid-cols-5 content-center">
              <div className="col-span-3 flex items-center">
                <img src={Logo} className="sm:h-7 sm:w-7 w-4 h-4" alt="Logo" />
                <p className="font-helios tracking-widest ml-1 text-white text-[8px] sm:text-sm ">
                  PT Pandawa Jaya Sejahtera
                </p>
              </div>
              <div className="col-span-2 flex items-center justify-center">
                <p className="font-montserrat text-white text-[4px] sm:text-xs">
                  Part of PT Pandawa Jaya Steel | memproduksi pipa dan hollow
                </p>
              </div>
            </div>
          </div>
        </section>
      </Link>
      <section className="block" style={platStyle}>
        <section className="bg-black/90 py-2 sm:py-2 py-4">
          <div className="container-screen">
            <h1 className="text-start font-helvetica text-white text-xs sm:text-xl mb-2 sm:mb-4">
              OUR CONTACT
            </h1>

            {/* Desktop Layout */}
            <div className="hidden sm:grid sm:grid-cols-4">
              <div className="col-span-3 justify-items-start">
                <div className="flex items-center">
                  <EnvelopeIcon className="h-5 w-5 text-white my-1" />
                  <p className="font-montserrat text-white ml-3 text-xs tracking-wide">
                    Pjs@pandawajayasteel.co.id
                  </p>
                </div>
                <div className="flex items-center my-1">
                  <PhoneIcon className="h-5 w-5 text-white my-1" />
                  <p className="font-montserrat text-white ml-3 text-xs tracking-wide">
                    (021) 5437 5641 / (021) 5437 5252
                  </p>
                </div>
                <div className="flex items-center my-1">
                  <img src={WhatsApp} className="h-5 w-5" alt="WhatsApp" />
                  <p className="font-montserrat text-white ml-3 text-xs tracking-wide">
                    +62 813-9933-0096 / +62 813-9933-0095
                  </p>
                </div>
              </div>
              <div className="col-span-1">
                <Link
                  to="https://www.instagram.com/pt.pandawajayasteel/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="flex items-center my-1">
                    <img
                      src={Instagram}
                      className="h-5 w-5 my-1"
                      alt="Instagram"
                    />
                    <p className="font-montserrat text-white ml-3 text-xs tracking-wide">
                      @pt.pandawajayasteel
                    </p>
                  </div>
                </Link>

                <Link
                  to="https://www.tiktok.com/@pt.pandawajayaste?_r=1&_t=ZS-91O7ko3QGRc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="flex items-center my-1">
                    <svg
                      className="h-5 w-5 text-white my-1"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                    </svg>
                    <p className="font-montserrat text-white ml-3 text-xs tracking-wide">
                      @pt.pandawajayaste
                    </p>
                  </div>
                </Link>

                <Link
                  to="https://www.linkedin.com/company/ptpandawajayasteel/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="flex items-center my-1">
                    <img
                      src={LinkedIn}
                      className="h-5 w-5 my-1"
                      alt="LinkedIn"
                    />
                    <p className="font-montserrat text-white ml-3 text-xs tracking-wide">
                      PT. Pandawa Jaya Steel
                    </p>
                  </div>
                </Link>
              </div>
            </div>

            {/* Mobile Layout - REDESIGNED */}
            {/* Mobile Layout - REDESIGNED */}
            <div className="sm:hidden">
              {/* Contact Info di Atas */}
              <div className="space-y-2 mb-4">
                <div className="flex items-center">
                  <EnvelopeIcon className="h-4 w-4 text-white flex-shrink-0" />
                  <p className="font-montserrat text-white ml-3 text-[10px] tracking-wide">
                    Pjs@pandawajayasteel.co.id
                  </p>
                </div>
                <div className="flex items-center">
                  <PhoneIcon className="h-4 w-4 text-white flex-shrink-0" />
                  <p className="font-montserrat text-white ml-3 text-[10px] tracking-wide">
                    (021) 5437 5641 / (021) 5437 5252
                  </p>
                </div>
                <div className="flex items-center">
                  <img
                    src={WhatsApp}
                    className="h-4 w-4 flex-shrink-0"
                    alt="WhatsApp"
                  />
                  <p className="font-montserrat text-white ml-3 text-[10px] tracking-wide">
                    +62 813-9933-0096 / +62 813-9933-0095
                  </p>
                </div>
              </div>

              {/* Social Media Icons di Bawah */}
              <div className="flex justify-start gap-8 pt-4 border-t border-white/20">
                <Link
                  to="https://www.instagram.com/pt.pandawajayasteel/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-70 transition-opacity"
                >
                  <img src={Instagram} className="h-5 w-5" alt="Instagram" />
                </Link>

                <Link
                  to="https://www.tiktok.com/@pt.pandawajayaste?_r=1&_t=ZS-91O7ko3QGRc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-70 transition-opacity"
                >
                  <svg
                    className="h-5 w-5 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                  </svg>
                </Link>

                <Link
                  to="https://www.linkedin.com/company/ptpandawajayasteel/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-70 transition-opacity"
                >
                  <img src={LinkedIn} className="h-5 w-5" alt="LinkedIn" />
                </Link>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default Footer;
